import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, styled, Typography } from '@mui/material';

import { Image } from '../Image/Image';
import { StyledTooltip } from '../StyledTooltip/StyledTooltip';

import { LeaderboardTooltip } from './LeaderboardTooltip';
import { LeaderboardRating } from './leaderboardTypes';
import { PlayIcon } from './PlayIcon';

interface LeaderboardHeaderProps {
  fullName: string;
  score: number;
  openModal: VoidFunction;
  videoPreviewImage?: string;
  rating?: LeaderboardRating;
  hideRating?: boolean;
}

const StyledLeaderboardScore = styled(Typography)(({ theme }) => ({
  width: 60,
  height: 30,
  display: 'block',
  textAlign: 'center',
  backgroundColor: theme.palette.grey[700],
  borderRadius: theme.spacing(1),
  color: theme.palette.grey[100],
  marginRight: theme.spacing(2),
  cursor: 'pointer',
}));

export const LeaderboardHeader = ({
  fullName,
  score,
  openModal,
  videoPreviewImage,
  rating,
  hideRating,
}: LeaderboardHeaderProps) => {
  const { t } = useTranslation('components', { keyPrefix: 'leaderboard' });

  return (
    <Box sx={{ backgroundColor: '#1BFFAF', pt: 4, pl: 7.5, pr: 6, pb: 4, borderRadius: '12px 12px 0 0' }}>
      <Typography variant="h4" color="grey.900">
        {t('title')}
      </Typography>
      <Box display="flex" alignItems="center" alignContent="space-between">
        <StyledTooltip title={fullName} sx={{ zIndex: 1 }}>
          <Typography variant="text1" mr={3} noWrap maxWidth={164} width={164} color="grey.900">
            {`🏆 ${fullName}`}
          </Typography>
        </StyledTooltip>

        <Box display="flex" alignItems="center">
          {hideRating ? (
            <StyledLeaderboardScore sx={{ cursor: 'default' }} variant="text1">
              {Math.round(score * 10) / 10}
            </StyledLeaderboardScore>
          ) : (
            <LeaderboardTooltip rating={rating}>
              <StyledLeaderboardScore variant="text1">{Math.round(score * 10) / 10}</StyledLeaderboardScore>
            </LeaderboardTooltip>
          )}

          <Box
            position="relative"
            sx={{
              '&:hover': {
                cursor: 'pointer',
              },
            }}
            onClick={openModal}
          >
            <Image
              src={videoPreviewImage || ''}
              sx={{
                width: 93,
                height: 59,
                borderRadius: 1,
              }}
            />

            <PlayIcon />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
